// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar__sidebar__d5bxo","search_field":"Sidebar__search_field__w3EcG"};